import { BrandSlice } from "slices/brand/brand-slice";

export default BrandSlice.reducer;

export const { setBrand } = BrandSlice.actions;
